<template>
  <div id="grid-validaciones-especificacion">
    <div class="sub-titulo">
      <v-subheader class="sub-titu">
        - Proveedor: {{ nombreProveedor }}, Contrato: {{ codContrato }},
        Período: {{ perContrato }}</v-subheader
      >
    </div>
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Registros configuración de la jornada&nbsp;
        </v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaIniFormatted"
                label="Fecha de inicio"
                prepend-icon="event"
                @click="menu1 = !menu1"
                @blur="fechaFinValue = parseDate(fechaIniFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaIniValue"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaFinFormatted"
                label="Fecha de fin"
                prepend-icon="event"
                @click="menu2 = !menu2"
                @blur="fechaFinValue = parseDate(fechaFinFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaFinValue"
              @input="menu2 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData(true)"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsEspecificacion"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.fechaIni }}</td>
                  <td class="text-xs-left">{{ props.item.fechaFin }}</td>
                  <td class="text-xs-left">{{ props.item.numHoras }}</td>
                  <td class="text-xs-left">{{ props.item.numPersonas }}</td>
                  <td>
                    <v-btn
                      v-if="usuarioLoggedTipe != 'PROVEEDOR'"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="red"
                      small
                      title="Eliminar registro"
                      @click="eliminar(props.item.id)"
                    >
                      <v-icon>clear</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <!-- LEYENDA -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                depressed
                outline
                icon
                fab
                dark
                color="red"
                small
                title="Eliminar archivo"
              >
                <v-icon>clear</v-icon></v-btn
              >
              &nbsp;Eliminar registro
            </v-card-actions>

            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="totalRegs"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pages"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>

            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                :disabled="botonDescarga"
                color="primary"
                @click="descarga()"
                >Descarga<v-icon right dark>folder</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </template>

          <v-dialog v-model="descargaLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-validaciones-especificacion",

  components: {
    AlertEmpty,
    Loading,
    LoadingDescarga,
  },
  props: {},

  data() {
    return {
      botonDescarga: true,
      loading: false,
      alerta: false,
      descargaLoading: false,
      idContrato: "",
      usuarioLoggedTipe: "",
      nombreProveedor: "",
      codContrato: "",
      perContrato: "",
      headers: [
        {
          text: "Fecha de inicio",
          align: "left",
          sortable: false,
          value: "fecha",
        },
        { text: "Fecha de término", sortable: false, value: "fechaFin" },
        { text: "Cantidad de horas", sortable: false, value: "horas" },
        { text: "Número de pesonas", sortable: false, value: "personas" },
        { text: "Accion", sortable: false, value: "" },
      ],
      itemsEspecificacion: [],
      idArchivoEspecificacion: -1,
      menu1: false,
      fechaIniValue: "",
      fechaIniFormatted: null,
      menu2: false,
      fechaFinValue: "",
      fechaFinFormatted: null,

      //paginacion por DB
      page: 1,
      pages: 1,
      totalRegs: 0,
      rowsPerPageItems: [20],
    };
  },
  watch: {
    descargaLoading(val) {
      if (!val) return;

      setTimeout(() => (this.descargaLoading = false), 5000);
    },
    fechaIniValue(val) {
      this.fechaIniFormatted = this.formatDate(this.fechaIniValue);
    },
    fechaFinValue(val) {
      this.fechaFinFormatted = this.formatDate(this.fechaFinValue);
    },
  },

  created() {
    // console.log("EspecificacionValidaciones");
    this.idContrato = this.$store.getters.contratoStored;

    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idArchivoEspecificacion = this.$route.query.idArchivoEspecificacion;
    // console.log("this.idArchivoEspecificacion:" + this.idArchivoEspecificacion);
    this.nombreProveedor = this.$store.getters.nombreProveedorStored;
    this.codContrato = this.$store.getters.contratoCodStored;
    this.perContrato = this.$store.getters.contratoPerStored;
    this.loadData(true);
  },
  mounted() {},
  computed: {},
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    descarga() {
      this.descargaLoading = true;
      let fileName = "Especificacion_Servicios.xlsx";

      var url = "/validaciones/descargaEspecificacion";
      this.body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        fechaIni:
          this.fechaIniValue && this.fechaIniValue != null
            ? this.formatDate(this.fechaIniValue) + " 00:00"
            : null,
        fechaFin:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.formatDate(this.fechaFinValue) + " 23:59"
            : null,
      };
      axios
        .post(url, this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadEspecificacion() {
      this.body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        fechaIni:
          this.fechaIniValue && this.fechaIniValue != null
            ? this.formatDate(this.fechaIniValue) + " 00:00"
            : null,
        fechaFin:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.formatDate(this.fechaFinValue) + " 23:59"
            : null,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/validaciones/getEspecificacion/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData(limpiar) {
      if (limpiar) this.page = 1;
      this.loading = true;

      let result = await this.loadEspecificacion();
      this.itemsEspecificacion = result.especificaciones;

      if (result.totalRegistros > 0) {
        this.totalRegs = result.totalRegistros;
        this.pages = Math.ceil(this.totalRegs / this.rowsPerPageItems);
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.totalRegs = 0;
        this.page = 1;
        this.pages = 0;
        this.alerta = true;
        this.botonDescarga = true;
      }
      this.loading = false;
    },
    volver() {
      this.$store.commit("tab_state", "Proceso");
      this.$store.commit("sub_pro_tab_state", "Validaciones");
      this.$store.commit("sub_tab_state", "Configuración de la jornada");
      this.$router.push({
        name: "ProcesoValidaciones",
      });
    },
    clear() {
      this.rutValue = "";
      this.nombreValue = "";
      this.fechaIniValue = "";
      this.fechaFinValue = "";
      this.loadData(true);
    },
    eliminar(idEspecificacion) {
      let body = {
        idContrato: this.idContrato,
        idEspecificacion: idEspecificacion,
        idUsuario: this.$store.getters.userLogged.id,
      };
      return axios
        .post("/validaciones/eliminarEspecificacion/", body)
        .then((response) => {
          this.loadData(true);
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>